export const Marquee = ({ items }) => {
  const list = items || [
    "Safe Skincare",
    "Handcrafted in Port Harcourt",
    "Glow Naturally",
    "Educate First",
    "Real Results",
  ];
  const doubled = [...list, ...list];
  return (
    <div className="bg-espresso text-bone py-4 overflow-hidden border-y border-espresso" data-testid="marquee">
      <div className="animate-marquee whitespace-nowrap flex w-max">
        {doubled.map((t, i) => (
          <span key={i} className="mx-8 font-serif italic text-lg tracking-widest uppercase flex items-center gap-8">
            {t}
            <span className="text-terracotta not-italic">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
